import {PlanningParameterItem} from './planning-parameter-item';

export class PlanningParameterItemCollection {
    private totalItems: number = 0;
    private planningParameterItems: PlanningParameterItem[] = [];

    setTotalItems(totalItems: number) {
        this.totalItems = totalItems;
    }

    setPlanningParameterItems(planningParameterItems: PlanningParameterItem[]) {
        this.planningParameterItems = planningParameterItems;
    }

    getTotalItems(): number {
        return this.totalItems;
    }

    getPlanningParameterItems(): PlanningParameterItem[] {
        return this.planningParameterItems;
    }
}
